import { LANGUAGE } from "@/common/utils/constants.js";

export const ERROR_PAGE = {
	[LANGUAGE.en.short]: {
		pageNotFound: "Page not found",
		message: "Oops! The page you are looking for does not exist.",
		reportAProblem: "Report a problem",
		reportIdea: 'Report idea',
		toHomePage: "Back to Home"
	},
	[LANGUAGE.de.short]: {
		pageNotFound: "Seite nicht gefunden",
		message: "Hoppla! Die Seite, die Sie suchen, existiert nicht.",
		reportAProblem: "Ein Problem melden",
		reportIdea: 'Berichtsidee',
		toHomePage: "Zurück zur Startseite"
	},
	[LANGUAGE.fr.short]: {
		pageNotFound: "Page non trouvée",
		message: "Oups ! La page que vous recherchez n'existe pas.",
		reportAProblem: "Signaler un problème",
		reportIdea: 'Idée de rapport',
		toHomePage: "Retour à la page d'accueil"
	},
	[LANGUAGE.it.short]: {
		pageNotFound: "Pagina non trovata",
		message: "Ops! La pagina che stai cercando non esiste.",
		reportAProblem: "Segnala un problema",
		reportIdea: 'Idea di report',
		toHomePage: "Torna alla home page"
	},
	[LANGUAGE.ja.short]: {
		pageNotFound: "ページが見つかりません",
		message: "おっとっと！ お探しのページは存在しません。",
		reportAProblem: "問題を報告します",
		reportIdea: 'レポートのアイデア',
		toHomePage: "ホームに戻る"
	},
	[LANGUAGE.es.short]: {
		pageNotFound: "Página no encontrada",
		message: "¡Vaya! La página que buscas no existe.",
		reportAProblem: "Reportar un problema",
		reportIdea: 'Idea para reportar',
		toHomePage: "Volver a la página de inicio"
	}
}
